import { ResearchSource } from './ResearchSource.mjs'

/**
 * GenericSource is a class that holds note and annotation information about a
 * generic source of research.
 *
 * @extends ResearchSource
 */
export class GenericSource extends ResearchSource {
  static TYPE = 'generic'
  constructor(yMap) {
    super(yMap)
  }

  get title() {
    return this.yMap.get('title') || ''
  }

  /** @deprecated prefer ./utils/researchSourceContainsString */
  containsString(searchString, notesMap = {}) {
    return (
      this.title?.toLowerCase().includes(searchString.trim()) ||
      super.containsString(searchString, notesMap)
    )
  }
}
